module.exports = __webpack_public_path__ + "static/media/facebook.fac18901.svg";